"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrderStatus = void 0;
const cloneObject_1 = require("../cloneObject");
const addOrderLog_1 = require("./addOrderLog");
const updateOrder_1 = require("./updateOrder");
const updateOrderStatus = async (supabase, order, status, created_by) => {
    const updated_order = (0, cloneObject_1.cloneObject)(order);
    updated_order.status = status;
    try {
        await (0, addOrderLog_1.addOrderLog)(supabase, {
            type: "ORDER",
            order_id: order?.id,
            created_by: created_by || undefined,
            detail: {
                type: "Order Status Update",
                status: status,
                title: order.reference,
                message: null,
            },
        });
        //TODO : Get the order summary and add it to the message e.g. Order Summary: Anantara Hua Hin (4 nights), 3 rounds of golf, 5 transfers
    }
    catch (e) {
        console.log("Error adding order log", e);
    }
    // set the order status to CONFIRMING_GOLF
    await (0, updateOrder_1.updateOrder)(supabase, updated_order);
};
exports.updateOrderStatus = updateOrderStatus;
